import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { withRouter, WithRouterProps } from '../../../../utils/withRouter';;
import { checkOrderConfirmationResponse, confirmOrderPayload } from '../../../../models/entities/shipment/public/orderConfirmation';
import { localizationSelectors } from '../../../../state/ducks/localization/selectors';
import { RootState, Dispatch } from '../../../../state/store/store';
import Loader from '../../../shared/SmallComponents/Loader';
import ExceptionPage from '../../ExceptionPage/ExceptionPage';
import OrderConfirmationPage from './OrderConfirmationPage';

type RouteParams = {
    token: string;
};

type Props = WithRouterProps<RouteParams> & {
    localization: any;
    checkOrderConfirmed: (token: string) => Promise<checkOrderConfirmationResponse>;
    confirmOrder: (payload: confirmOrderPayload) => Promise<void>;
    fetchError?: string;
};

const OrderConfirmationPageConnected = ({ localization, checkOrderConfirmed, confirmOrder, fetchError, params }: Props) => {
    const location = useLocation();
    const [checkOrderConfirmation, setCheckOrderConfirmation] = useState<checkOrderConfirmationResponse | null>(null);
    const token = params.token;

    useEffect(() => {
        (async () => {
            const response = await checkOrderConfirmed(token);
            setCheckOrderConfirmation(response);
        })();
    }, [token]);

    if (fetchError) {
        let error = { message: undefined, status: 500 };
        try {
            error = JSON.parse(fetchError);
        } catch (e) {}
        return <ExceptionPage status={error.status} title={error.message || ''} />;
    }

    if (!checkOrderConfirmation) return <Loader />;

    return <OrderConfirmationPage localization={localization} confirmOrder={confirmOrder} checkOrderConfirmedResp={checkOrderConfirmation} />;
};

const mapStateToProps = (state: RootState) => ({
    fetchError: state.error.effects.shipments.checkOrderConfirmed,
    localization: localizationSelectors.orderConfirmationPage(state)
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    checkOrderConfirmed: (token: string) => dispatch.shipments.checkOrderConfirmed(token) as unknown as Promise<checkOrderConfirmationResponse>,
    confirmOrder: (payload: confirmOrderPayload) => dispatch.shipments.confirmOrder(payload) as unknown as Promise<void>
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(OrderConfirmationPageConnected));
